// extracted by mini-css-extract-plugin
module.exports = {"container":"CollapsableMenu_container__BxC9D","row":"CollapsableMenu_row__eAeTo"};